import axios from '../configV2.js';
const resource = '/case';

export default {
  /**
   * Gets the case info
   * If no ID, gets all the case info available
   * @param {Number} id User ID (optional)
   */
  get(id='', no_doctor=null, status=null, page=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    const params = new URLSearchParams();
    if (no_doctor)  params.append('no_doctor', '');
    if (status)     params.append('status', status);
    if (page)     params.append('page', page);
    return axios.get(`${resource}${id ? `/${id}`: ''}`, { params: params });
  },
  getByPatientId(id='', per_page=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    if (per_page)  params.append('per_page', per_page);
    return axios.get(`${resource}?patient_id=${id}`, { params: params });
  },
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;

    return axios.post(`${resource}`, payload);
  }
};